import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import styles from "./keyfobs.module.css";
import Loader from "../../../components/Loader";
import KeyfobFilter from "./components/KeyfobFilter";
import KeyfobCard from "./components/KeyfobCard";
import { Helmet } from "react-helmet";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Slide, Snackbar, TablePagination, Typography } from "@mui/material";
import { Home, X } from "react-feather";
import { useEffect, useState } from "react";
import Footer from "../../../components/Footer";
import { TableLoader } from "../../../components/LoaderC";
import axios from "axios";
import { toast } from 'react-smart-toaster';
import AddLockKeyFobForm from "../AddComponent/AddLockKeyFobForm";
import KeyfobListMobile from "./components/KeyfobListMobile";

const Keyfobs = () => {
    const { getAccessTokenSilently } = useAuth0();
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteCardNumber, setDeleteCardNumber] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState("");
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(8);
    const [filterData, setFilterData] = useState({ searchKey: "", property: "", type: "" });
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [keyfobAllList, setFeyfobAllList] = useState([]);
    const [keyfobList, setFeyfobList] = useState([]);
    const [showAddFormKeyFob, setShowAddFormKeyFob] = useState(false);

    useEffect(() => {
        const fetchKeyFobs = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            axios(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/key-fobs", {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setContentLoading(false);
                setFeyfobAllList(response.data.data);
            }).catch(() => {
                setContentLoading(false);
            });
        };
        fetchKeyFobs();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        let deviceListTemp = keyfobAllList;
        if (filterData.searchKey !== "") {
            let inputVal = filterData.searchKey.toLowerCase();

            deviceListTemp = deviceListTemp.filter((item) => {
                const nameMatch = item?.card_name?.toLowerCase().includes(inputVal);
                const numberMatch = item?.card_number?.toLowerCase().includes(inputVal);
                const typeMatch = item?.card_type?.toLowerCase().includes(inputVal);

                const lockMatch = Array.isArray(item?.associated_locks) && item.associated_locks.some((kf) => kf.toString().toLowerCase().includes(inputVal));

                return (nameMatch || numberMatch || typeMatch || lockMatch);
            });
        }

        if (filterData.property !== "" && filterData.property !== "all") {
            deviceListTemp = deviceListTemp.filter((i) => i.property_id?.indexOf(filterData.property) > -1);
        }

        if (filterData.type !== "" && filterData.type !== "all") {
            deviceListTemp = deviceListTemp.filter((i) => i.card_type === filterData.type);
        }

        setFeyfobList(deviceListTemp);
    }, [keyfobAllList, filterData]);

    const confirmDelete = async () => {
        setDeleteModalOpen(false);
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.delete(process.env.REACT_APP_DEVICE_API_URL + 'v1/ttlock/key-fobs/' + deleteCardNumber, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);
            setLoading(false);

            setFeyfobAllList(prev => {
                return prev?.filter(i => i?.card_number !== deleteCardNumber);
            });

            setDeleteCardNumber("");
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }


    const onKeyFobAdd = (data) => {
        if (data.length > 0) {
            let lockList = data?.map(i => {
                return i?.lock_name_new;
            });

            var keyfobObj = {
                associated_locks: lockList,
                card_name: data[0]?.card_name,
                card_number: data[0]?.card_number,
                card_type: data[0]?.card_type,
                group_id: data[0]?.id,
                property_id: [data[0]?.lock_property],
            };

            setFeyfobAllList(prev => {
                return prev.concat([keyfobObj]);
            });
        }
    }

    return <>
        {loading && <Loader />}

        <Helmet title="Manage KeyFob" />

        <div className={`${styles.pageTitleWrap}`}>
            <Typography display="inline" className={`${styles.pageTitle}`}>Manage Keyfob</Typography>
            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Smart Device</li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>Manage Keyfob</li>
                </ol>
            </nav>
        </div>

        <div className={`${styles.BodyCon}`}>
            <div className={`${styles.mainCardDiv}`}>
                <div className={`${styles.mainCard}`}>
                    {contentLoading && (<div className="Loader TableLoader">
                        <TableLoader />
                    </div>)}

                    {!contentLoading && (<div className="control-pane">
                        <div className={`${styles.Row}`}>

                            <KeyfobFilter filterData={filterData} setFilterData={setFilterData.bind(this)} setShowAddFormKeyFob={setShowAddFormKeyFob.bind(this)} setPage={setPage.bind(this)} />

                            <div className={`${styles.NotesRow}`}>

                                {keyfobList.map((item, index) => {
                                    return perPage === -1 || (index >= page * perPage && index < page * perPage + perPage) ? (<KeyfobCard item={item} setDeleteModalOpen={setDeleteModalOpen.bind(this)} setDeleteCardNumber={setDeleteCardNumber.bind(this)} setFeyfobList={setFeyfobList.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} setLoading={setLoading.bind(this)} />) : null;
                                })}

                                {keyfobList.length > 0 && (<div className="Pagination TablePaginationNew List">
                                    <TablePagination
                                        count={keyfobList.length}
                                        color="primary"
                                        page={page}
                                        rowsPerPage={perPage}
                                        onPageChange={(e, v) => setPage(v)}
                                        rowsPerPageOptions={[
                                            { label: "4", value: 4 },
                                            { label: "8", value: 8 },
                                            { label: "16", value: 16 },
                                            { label: "All", value: -1 },
                                        ]}
                                        onRowsPerPageChange={(e) => {
                                            setPage(0);
                                            setPerPage(e.target.value);
                                        }}
                                        labelRowsPerPage={"Keyfobs per Page:"}
                                    />
                                </div>)}

                                {keyfobList.length === 0 && (<div className={`${styles.NoDataMain}`}>
                                    <div className={`${styles.NoDataIMG}`}>
                                        <img src="/static/img/no-keyfob.png" alt="No Data" />
                                    </div>
                                    <p className={`${styles.NoDataText}`}>Let's fill it up!</p>
                                    <p className={`${styles.NoDataTextSub}`}>Keyfob List is Currently Empty.</p>
                                </div>)}

                            </div>

                            <div className={`${styles.ListMobileView}`}>
                                {keyfobList.map((item, index) => {
                                    return perPage === -1 || (index >= page * perPage && index < page * perPage + perPage) ? (<KeyfobListMobile item={item} setDeleteModalOpen={setDeleteModalOpen.bind(this)} setDeleteCardNumber={setDeleteCardNumber.bind(this)} />) : null;
                                })}
                                {keyfobList.length === 0 && (<div className={`${styles.NoDataMain}`}>
                                    <div className={`${styles.NoDataIMG}`}>
                                        <img src="/static/img/no-keyfob.png" alt="No Data" />
                                    </div>
                                    <p className={`${styles.NoDataText}`}>Let's fill it up!</p>
                                    <p className={`${styles.NoDataTextSub}`}>Keyfob List is Currently Empty.</p>
                                </div>)}
                            </div>

                        </div>
                    </div>)}
                </div>
            </div>
        </div>

        <Dialog
            open={deleteModalOpen}
            onClose={(e) => setDeleteModalOpen(false)}
            fullWidth
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">
                Would you like to delete this keyfob?
                <button onClick={(e) => setDeleteModalOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent>
                <div className="ModalFormGroup">
                    <label className="PopupBodyText">The keyfob information will be removed immediately. You can't undo this action.</label>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={(e) => confirmDelete()} className="CancelPopupBU">Delete</Button>
                <Button onClick={(e) => setDeleteModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={showAddFormKeyFob}
            onClose={(e) => {
                setShowAddFormKeyFob(false);
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm CustomWidthPops"
        >
            <AddLockKeyFobForm
                setShowAddFormKeyFob={setShowAddFormKeyFob.bind(this)}
                setSnackbarOpen={setSnackbarOpen.bind(this)}
                setSnackbarMsg={setSnackbarMsg.bind(this)}
                onSubmitLocal={onKeyFobAdd.bind(this)}
            />
        </Dialog>

        <Snackbar
            open={snackbarOpen}
            onClose={(e) => setSnackbarOpen(false)}
            TransitionComponent={Slide}
            message={snackbarMsg}
            autoHideDuration={10000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={(e) => setSnackbarOpen(false)}
                >
                    <X />
                </IconButton>
            }
        />

        <Footer />
    </>
}

export default withAuthenticationRequired(Keyfobs, {
    onRedirecting: () => <Loader />,
});